// FindPasswordEmailVerificationPanel.js
import React, { useState, useRef } from 'react';
import styles from './FindPasswordEmailVerificationPanel.module.css'; 
import axios from "../../../../utils/api/axios";
import { EMAIL_VERIFICATION, } from '../../../../utils/Config'; 
import { InnocodeButton, useDialog } from '@intsoft/innocode-core';

function FindPasswordEmailVerificationPanel({ onNext, fullEmail }) {
    const [code, setCode] = useState('');
    const inputRefs = useRef([]);
    const buttonRef = useRef(null);
    const { showDialog } = useDialog();
    // 인증 코드가 6자리 모두 채워졌는지 확인하는 상태
    const isNextButtonEnabled = code.length === 6;

    // input 값 변경 핸들러
    const handleCodeChange = (e, index) => {
        const value = e.target.value;
        const newCode = code.split('');
        newCode[index] = value;
        
        const updatedCode = newCode.join('').slice(0, 6);
        setCode(updatedCode);

        // 다음 칸으로 포커스 이동
        if (value && index < 5 && inputRefs.current[index + 1]) {
            inputRefs.current[index + 1].focus();
        } else if (value && index === 5) {
            // 마지막 칸에 입력되면 버튼으로 포커스 이동
            setTimeout(() => {
                if (updatedCode.length === 6 && buttonRef.current) {
                    buttonRef.current.focus();
                }
            }, 100);
        }
    };

    // 붙여넣기 핸들러
    const handlePaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData('text').trim();
        
        if (pasteData.length === 6 && /^[0-9]+$/.test(pasteData)) {
            setCode(pasteData);
            // 버튼으로 포커스 이동
            setTimeout(() => {
                if (buttonRef.current) {
                    buttonRef.current.focus();
                }
            }, 150);
        }
    };

    // 키보드 입력 핸들러
    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !e.target.value && index > 0 && inputRefs.current[index - 1]) {
            // 현재 칸이 비어있을 때 백스페이스 누르면 이전 칸으로 이동
            inputRefs.current[index - 1].focus();
        } else if (e.key === 'Enter') {
            // Enter 키를 누르면 모든 값이 채워진 경우 검증 실행
            if (code.length === 6) {
                e.preventDefault();
                handleVerifyCode();
            }
        }
    };
    const handleVerifyCode = async () => {
        try { 
            const verifyRes = await axios.post(`${EMAIL_VERIFICATION}/email/verify?email=${fullEmail}&code=${code}`);

            if (verifyRes.data.code === 200) {
                onNext(true);
            } else {
                // showDialog(DialogEnum.DEFAULT, "실패", "인증 코드가 올바르지 않습니다.");
                showDialog({
                  iconType: "warning",
                  type: 'error',
                  title: "오류",
                  message: "인증 코드가 올바르지 않습니다.",
              });
            }
        } catch (err) {
            console.error("인증 코드 확인 오류:", err);
            showDialog({
                iconType: "warning",
                type: 'error',
                title: "오류",
                message: "인증 코드 확인 중 오류가 발생했습니다.",
            });
        }
    };

  return (
    <div className={styles.content_wrapper}> 
      <div className={styles.signup_section}>
        <div className={styles.signup_title_row}>
          <div className={`${styles.signup_title} innocode-typography--title-sm innocode-typography--bold`}>
            입력하신 이메일로 인증코드를 전송했어요.
          </div>
          <div className={`${styles.signup_description} innocode-typography--body-md-reading innocode-typography--medium`}>
            "Zentry" 이름으로 온 메일에서 인증코드를 확인해주세요.
          </div>
        </div>
        <div className={styles.email_verify_code_row}>
            {Array.from({ length: 6 }).map((_, index) => (
                <input
                    key={index}
                    type="text"
                    maxLength={1}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    className={styles.email_verify_code_box}
                    value={code[index] || ''}
                    onChange={(e) => handleCodeChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    onPaste={handlePaste}
                    ref={el => inputRefs.current[index] = el}
                />
            ))}
        </div>
      </div>
      <div className={styles.submit_btn_container}>
        {/* <button
          type="button"
          className={`${components.btn} ${components.btn_solid} ${components.btn_primary} ${components.btn_lg} ${styles.submit_btn} ${!isNextButtonEnabled ? styles.disabled : ''}`}
          onClick={handleVerifyCode}
          disabled={!isNextButtonEnabled}
        >
          <span className={components.btn__text}>다음</span>
        </button> */}
        <InnocodeButton
          ref={buttonRef}
          size="lg"
          onClick={handleVerifyCode}
          disabled={!isNextButtonEnabled}
          className={styles.submit_btn}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && isNextButtonEnabled) {
              e.preventDefault();
              handleVerifyCode();
            }
          }}
        >다음</InnocodeButton>
      </div>
    </div>
  );
}

export default FindPasswordEmailVerificationPanel;